export default class Cards {
    constructor(element) {
        this.el = element;
        this.activate = this.activate.bind(this);
        this.connect();
    }

    connect() {
        if (!this.el) return;
        
        this.button = this.el.querySelector('[cards-button]');
        if (this.button) {
            this.button.addEventListener('click', this.activate);
        }
    }

    disconnect() {
        if (this.button) {
            this.button.removeEventListener('click', this.activate);
        }
    }

    activate(e) {
        e.preventDefault();
        
        // Add the class that shows hidden cards
        this.el.classList.add('is-cards-active');
        
        // Focus management for keyboard accessibility
        // Find the first newly visible card that has a focusable element
        setTimeout(() => {
            const cards = this.el.querySelectorAll('.cards__item');
            
            // Look through cards starting from the 7th (index 6) to find one with a focusable element
            for (let i = 6; i < cards.length; i++) {
                const card = cards[i];
                const focusableElement = card.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
                
                if (focusableElement) {
                    focusableElement.focus();
                    break;
                }
            }
        }, 200); // Shorter delay for better user experience
        
        // Optional: Hide the button after clicking
        if (this.button) {
            this.button.style.display = 'none';
        }
    }
}